// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"382":"30","443":"about"}[chunkId] + "." + {"382":"d510ac80","443":"ee0ad151"}[chunkId] + ".css";
};